export enum CommonQueryParamKey {
  PREV = 'prev',
}

export type CommonQueryParams = Partial<Record<CommonQueryParamKey, string>>;
